

export const SwiperBreakPoint = {
    280: { slidesPerView: 1, spaceBetween: 20 },
    650: { slidesPerView: 2, spaceBetween: 20 },
    900: { slidesPerView: 3, spaceBetween: 20 },
    1024: { slidesPerView: 3, spaceBetween: 30 },
    1280: { slidesPerView: 4, spaceBetween: 30 },
    1550: { slidesPerView: 5, spaceBetween: 30 },
  }